// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { JoHeader } from './jo-header';
import { JoPullBatch } from './jo-pull-batch';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class JoHeaderPull extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key FK joHeader */
  joHeaderId!: number;
  /** Int32 FK joPullBatch */
  joPullBatchId!: number;
  /** Binary */
  rowVersion!: any;
  /** FK joHeaderId */
  joHeader!: JoHeader;
  /** FK joPullBatchId */
  joPullBatch!: JoPullBatch;
}

